<h2 mat-dialog-title>{{ 'rangeDate.title' | translate }}</h2>
<mat-dialog-content style="width: 100%; margin: 0px;">
    <div>
        <p>{{ 'rangeDate.text' | translate }}</p>

    </div>

        <div>
            <!-- <mat-form-field style="margin-right: 10px;">
                <mat-label>{{ 'rangeDate.start_date' | translate }}</mat-label>
                <input matInput type="datetime" name="start_date" formControlName="start_date">
                <mat-icon matSuffix>calendar</mat-icon>
            </mat-form-field>
            <mat-form-field style="margin-left:10px">
                <mat-label>{{ 'rangeDate.end_date' | translate }}</mat-label>
                <input matInput type="datetime" name="end_date" formControlName="end_date">
                <mat-icon matSuffix>date</mat-icon>
            </mat-form-field> -->
            <mat-form-field #myFormField (click)="dp.open();" appearance="filled">
                <input
                  matInput
                  [matDatepicker]="dp"
                  placeholder="{{datePlaceholder}}"
                  disabled
                />
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker
                  #dp
                  disabled="false"
                  startView="year"
                  (yearSelected)="chosenYearHandler($event)"
                  (monthSelected)="chosenMonthHandler($event, dp)"
                  panelClass="example-month-picker"
                >
                </mat-datepicker>
              </mat-form-field>
        </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-dialog-close>
        <span>{{'rangeDate.cancel' | translate}}</span>
    </button>
    <button mat-flat-button (click)="getRangeDate()"
        style="color: white; background-color: #5fbeb5;">
        <span>{{ 'rangeDate.ok' | translate}}</span>
    </button>
    <mat-progress-bar *ngIf="showBar" mode="indeterminate"></mat-progress-bar>
</mat-dialog-actions>